import { Comentario } from './../modelo/Comentario';
import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { IApiResponse, PageProps } from '../modelo/PageProps';
import { Projeto, ProjetoResposta } from '../modelo/Projeto';
import { Observable } from 'rxjs';
import { Upload } from '../modelo/Upload';

@Injectable({
  providedIn: 'root'
})
export class ProjetosService {

  apiUrl: string = `${environment.backendUrl}/projetos`;

  vazio: any[] = [];

  constructor(private http: HttpClient) { }

    httpOptions = {
        headers: {
            'Content-Type': 'application/json',
        }
    }

    httpOptionsMultiPart = {
      headers: {
          //'Content-Type': 'application/json',
      }
  }

    getSolucoes(): Observable<string[]> {
      let searchParams = new HttpParams();
      return this.http.get<string[]>(`${this.apiUrl}/listaSolucoes`,
        { params: searchParams, headers: this.httpOptions.headers });
    }

    getOrigens(): Observable<string[]> {
      let searchParams = new HttpParams();
      return this.http.get<string[]>(`${this.apiUrl}/listaOrigens`,
        { params: searchParams, headers: this.httpOptions.headers });
    }

    getProjetos() {
      return this.getProjetosFiltro("", this.vazio);
    }

    private formatDate(date: Date): string {
      if (date == null)
        return "";
      const day = date.getDate().toString().padStart(2, '0');
      const month = (date.getMonth() + 1).toString().padStart(2, '0');
      const year = date.getFullYear().toString();
      return `${day}/${month}/${year}`;
    }

    getProjetosFiltro(
      tipoFiltro: string,
      filtroData: Date[]){

        console.info("Tipo Filtro: " + tipoFiltro);
        console.info("Datas: " + filtroData);

      let searchParams = new HttpParams()
        .set("tipoFiltro", tipoFiltro)
        .set("filtroData", filtroData.map(date =>
            this.formatDate(date)).join(";"));

      return this.http.get<PageProps<ProjetoResposta>>(`${this.apiUrl}`,
      { params: searchParams, headers: this.httpOptions.headers });
    }

    getHistorico(id: number, pageNumber: number, pageSize: number){
      let searchParams = new HttpParams();

      searchParams = searchParams.append(`page`, String(pageNumber));
      searchParams = searchParams.append(`size`, String(pageSize));

      return this.http.get<IApiResponse>(`${this.apiUrl}/aud/${id}`,
      { params: searchParams, headers: this.httpOptions.headers });
    }

  salvarProjeto(projeto: Projeto): Observable<any> {
      return this.http.post(`${this.apiUrl}`, this.serializarProjeto(projeto), { headers: this.httpOptions.headers });
  }

  editarProjeto( projeto: Projeto): Observable<any>{
      return this.http.put(`${this.apiUrl}/${projeto.id}`,
      this.serializarProjeto(projeto), { headers: this.httpOptions.headers });
  }

  private serializarProjeto(projeto: Projeto) {
    return {
      ...projeto,
      dtcadastro: this.serializarData(projeto.dtcadastro),
      dtcontrato: this.serializarData(projeto.dtcontrato),
      dtkickoff: this.serializarData(projeto.dtkickoff),
      dttestunit: this.serializarData(projeto.dttestunit),
      dttestinteg: this.serializarData(projeto.dttestinteg),
      dtgolive: this.serializarData(projeto.dtgolive),
    };
  }

  private serializarData(data?: Date | null): string | null {
    if (!data || Number.isNaN(data.getTime()))
      return null;

    const dia = data.getDate().toString().padStart(2, '0');
    const mes = (data.getMonth() + 1).toString().padStart(2, '0');
    return `${data.getFullYear()}-${mes}-${dia}`;
  }

    deletarProjeto(projeto: Projeto): Observable<any> {
      return this.http.delete(`${this.apiUrl}/${projeto.id}`, this.httpOptions);
    }

    validaEncerramento(projeto: Projeto): Observable<any> {
      return this.http.put(`${this.apiUrl}/validaEncerramento/${projeto.id}`, this.httpOptions);
    }

    modificaPesquisaSatisfacao(projeto: Projeto): Observable<any> {
      return this.http.put(`${this.apiUrl}/pesquisaSatisfacao/${projeto.id}`, this.httpOptions);
    }

    listarComentarios(comentario: Comentario) : Observable<any>{
      let searchParams = new HttpParams();
      return this.http.get<IApiResponse>(`${this.apiUrl}/comentarios/${comentario.projeto?.id}`,
       { headers: this.httpOptions.headers });
    }

    inserirComentario(comentario: Comentario): Observable<any> {
      return this.http.post(`${this.apiUrl}/comentarios`, comentario,{ headers: this.httpOptions.headers });
    }

    uploadFile(file: File , upload: Upload){
      const formData = new FormData();
        formData.append('file', file);
      return this.http.post(`${this.apiUrl}/arquivos/${upload.projeto?.id}`,
      formData, { headers: this.httpOptionsMultiPart.headers ,  observe: 'response', responseType: 'text' });
    }

    listarArquivos(upload: Upload): Observable<any>{
      let searchParams = new HttpParams();
      return this.http.get<IApiResponse>(`${this.apiUrl}/arquivos/${upload.projeto?.id}`,
       { headers: this.httpOptions.headers });
    }

    downloadFile(upload: Upload): Observable<Blob>{
      const projetoId = upload.projeto?.id;
    const filename = upload.nome;
    const url = `${this.apiUrl}/arquivos/download/${projetoId}/${filename}`;
    return this.http.get(url, { headers: this.httpOptions.headers, responseType: 'blob'});
    }
}
